<template>
  <section class="stretch stretch-right registration aos-init aos-animate" data-aos="fade-left" data-aos-offset="350">
    <div class="register-box-narrow centered">
      <div class="contents">
        <h2 class="uppercase">Sei un appassionato di musica?</h2>
        <p class="normal">Registrati e inizia a scaricare<br>Download gratuito</p>
        <router-link to="/signup" class="button button-regular button-aqua button-anim">Registrati</router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
}
</script>



// WEBPACK FOOTER //
// src/vue/components/RegisterBanner01.vue